import { Component, Input, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { filter, take, tap } from 'rxjs/operators';

import { AccountsBackend } from '@libs/src/accounts/accounts.backend';
import { GroupMatchExclusionsDrawerService } from '@main-client/src/app/group-match-exclusions-drawer/group-match-exclusions-drawer.service';
import { GroupMembershipDialogService } from '@main-client/src/app/group-membership-dialog/group-membership-dialog.service';

import {
  Account,
  AccountGroupMembership,
} from '@libs/src/models/account.model';
import { Group, GroupHiddenCustomSegment } from '@libs/src/models/group.model';
import { getHiddenSegmentsVisibleToUser } from '@libs/src/segment-selections/segment-selections.helper';
import { getMembership } from '@main-client/src/app/account/account.helpers';
import { IAppState } from '@main-client/src/app/app.state';

import isEmpty from 'lodash-es/isEmpty';

@Component({
  selector: 'app-account-edit-drawer',
  templateUrl: './account-edit-drawer.component.html',
})
export class AccountEditDrawerComponent implements OnInit {
  @Input() account: Account;
  @Input() group: Group;
  @Input() onUpdate: (updatedAccount: Account) => any;
  membership: AccountGroupMembership;
  isLoading = false;
  hiddenSegmentsToDisplay: GroupHiddenCustomSegment[] = [];
  userState = this.store.select('user').pipe(
    filter((user: Account) => !isEmpty(user)),
    take(1),
  );

  constructor(
    public accountsBackend: AccountsBackend,
    public groupMatchExclusionsDrawer: GroupMatchExclusionsDrawerService,
    public groupMembershipDialog: GroupMembershipDialogService,
    private store: Store<IAppState>,
  ) {}

  ngOnInit(): void {
    this.isLoading = true;
    this.accountsBackend
      .getAccount(this.account.slug)
      .pipe(
        tap(({ profile }) => {
          this.isLoading = false;
          this.initialize(profile, this.group);
        }),
      )
      .subscribe();

    this.initialize(this.account, this.group);
    this.userState
      .pipe(
        tap((user: Account) => {
          this.hiddenSegmentsToDisplay = getHiddenSegmentsVisibleToUser(
            this.group,
            user,
            this.account,
          );
        }),
      )
      .subscribe();
  }

  initialize(account: Account, group: Group) {
    this.account = account;
    this.membership = getMembership(this.account.groups, group._id);
    if (isEmpty(this.membership)) {
      return;
    }
  }

  openMembershipDialog(account: Account, group: Group) {
    return this.groupMembershipDialog
      .openDialog({
        account,
        group,
        onUpdate: (updatedAccount) => {
          this.initialize(updatedAccount, group);
          if (this.onUpdate) {
            this.onUpdate(updatedAccount);
          }
        },
      })
      .afterClosed()
      .subscribe();
  }

  openMatchExclusionDrawer(account: Account, group: Group) {
    return this.groupMatchExclusionsDrawer
      .openDrawer(account, group)
      .afterClose.pipe(
        filter((response: { account: Account }) => !isEmpty(response?.account)),
        tap((response: { account: Account }) =>
          this.initialize(response.account, group),
        ),
      )
      .subscribe();
  }
}
